<!-- TODO how to hide -->
<div class="details-card-wrapper">
  @if (uploadedFeatures.length) {
  <!-- Features  -->
  <div class="details-card">
    @for (feature of uploadedFeatures; track feature.title) {
    <base-feature [featureInput]="feature"></base-feature>
    }
  </div>
  } @else {
  <!-- No features available -->
  <div class="no-features">
    <p>No features available for this product.</p>
  </div>
  }
</div>
